import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Credential/";

const getCredentialById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetCredentialById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getCredentials = async (showArchived) => await axiosInstance.get(ENDPOINTORIGIN + 'GetCredentials?showArchived=' + showArchived, constants.REQUIRE_INTERCEPTORS);

const getCredentialsByTypeAndSubType = async (typeId, subTypeId) => await axiosInstance.get(ENDPOINTORIGIN + `GetCredentialsByTypeAndSubType?typeId=${typeId}&subTypeId=${subTypeId == 0 ? "" : subTypeId}`,
    constants.REQUIRE_INTERCEPTORS);

const saveCredential = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveCredential', model, constants.REQUIRE_INTERCEPTORS);

const archiveCredential = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'ArchiveCredential?id=' + id, constants.REQUIRE_INTERCEPTORS);

const unarchiveCredential = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'UnarchiveCredential?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getCredentialById,
    getCredentials,
    saveCredential,
    archiveCredential,
    getCredentialsByTypeAndSubType,
    unarchiveCredential
}